import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { Form, Button, Card, Modal, DropdownButton, Dropdown } from 'react-bootstrap';
import { DROPDOWN_BTN, formBackList } from './constants';
import { blackListSchema } from './schema';
import { Input, MaskInput, Textarea } from '../Forms';
import FormikFillFields from '../Forms/FormikFillFields';
import { postBlackListRequest } from '../../security/reports/ReportSpecialList/actions';

type Props = {
  show: boolean;
  closeHandler: () => void;
};

const AddToBlackList: React.FC<Props> = ({ show, closeHandler }) => {
  const dispatch = useDispatch();
  const [isReasonMode, setReasonMode] = useState<boolean>(false);
  const [btnDropdown, setBtnDropdown] = useState('driver');

  const [errText, setErrText] = useState<string>('');
  const formRef = useRef();

  useEffect(() => {
    if (!show) {
      setReasonMode(false);
    }
  }, [show]);

  const openReasonHandler = () => {
    setReasonMode(true);
  };

  const changeHandler = (e: any) => {
    const value = e?.target?.value;

    if (!value?.length) {
      setErrText("Поле обов'язкове");
    } else {
      setErrText('');
    }
  };

  const onAddBL = (values: any) => {
    if (btnDropdown === 'driver') {
      values.role = 0;
    }
    if (btnDropdown === 'forwarder') {
      values.role = 1;
    }
    if (btnDropdown === 'vehicle') {
      values.role = 2;
    }
    if (btnDropdown === 'trailer') {
      values.role = 3;
    }

    dispatch(postBlackListRequest(values));
    closeHandler();
  };

  const bodyVisitor = useMemo(
    () => (
      <div>
        <MaskInput
          name="number"
          label="Телефон"
          placeholder="38 (0XX) XXX-XX-XX"
          onChange={changeHandler}
          isOptRequired
        />
        <Input name="description" label="ПІБ" onChange={changeHandler} maxLength={40} isOptRequired />
      </div>
    ),
    [btnDropdown],
  );

  if (!show) return null;

  return (
    <Modal backdrop="static" keyboard={false} centered show={show} onHide={closeHandler}>
      <Formik
        initialValues={formBackList}
        // @ts-ignore
        innerRef={formRef}
        onSubmit={(values) => onAddBL(values)}
        validationSchema={() => blackListSchema(btnDropdown)}
        validateOnMount
        enableReinitialize
      >
        {({ handleSubmit, isValid, resetForm }) => (
          <form onSubmit={handleSubmit}>
            <FormikFillFields />
            <Card>
              <Card.Header className="font-weight-bold">Чорний список</Card.Header>
              {!isReasonMode ? (
                <Card.Body>
                  <DropdownButton
                    className="w-50 mb-2"
                    menuAlign="left"
                    variant="outline-secondary"
                    // @ts-ignore
                    title={DROPDOWN_BTN[btnDropdown]}
                  >
                    {Object.keys(DROPDOWN_BTN).map((o) => (
                      // @ts-ignore
                      <Dropdown.Item
                        key={`dropdown_${o}`}
                        as="button"
                        onClick={() => {
                          resetForm();
                          setBtnDropdown(o);
                        }}
                      >
                        {
                          // @ts-ignore
                          DROPDOWN_BTN[o]
                        }
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                  {btnDropdown === 'driver' ? bodyVisitor : null}
                  {btnDropdown === 'forwarder' ? bodyVisitor : null}

                  {btnDropdown === 'trailer' || btnDropdown === 'vehicle' ? (
                    <div>
                      <Input
                        name="number"
                        label="Держномер"
                        onChange={changeHandler} // @ts-ignore
                        maxLength={11}
                        minLength={4}
                        isOptRequired
                      />
                      <Input name="description" label="Марка" onChange={changeHandler} maxLength={40} isOptRequired />
                    </div>
                  ) : null}

                  <Form.Group>
                    <Form.Label className="mb-1">
                      Вкажіть причину: <span className="text-danger ml-2">*</span>
                    </Form.Label>
                    <Textarea name="comment" onChange={changeHandler} maxLength={150} onLine />
                    <Form.Control.Feedback type="invalid">{errText}</Form.Control.Feedback>
                  </Form.Group>

                  <div className="d-flex justify-content-around">
                    <Button className="mt-3 px-5" onClick={closeHandler} variant="outline-secondary">
                      Вийти
                    </Button>

                    <Button
                      className="mt-3 px-5"
                      onClick={openReasonHandler}
                      variant="outline-danger"
                      disabled={!isValid}
                    >
                      Додати
                    </Button>
                  </div>
                </Card.Body>
              ) : (
                <Card.Body>
                  <h6 className="text-center">Додати до чорного списку?</h6>
                  <div className="d-flex justify-content-around">
                    <Button className="mr-4 px-5" onClick={closeHandler} variant="outline-secondary">
                      Ні
                    </Button>
                    <Button className="px-5" type="submit" variant="outline-danger">
                      Так
                    </Button>
                  </div>
                </Card.Body>
              )}
            </Card>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddToBlackList;
